import { questionSchema, questionTypeSchema } from '@entities/lesson'
import { z } from 'zod'

export const lessonReviewAnswerStatusSchema = z.enum(['CORRECT', 'INCORRECT', 'NOT_ANSWERED'])

export type LessonReviewAnswerStatus = z.infer<typeof lessonReviewAnswerStatusSchema>

export const lessonReviewAnswerSchema = z.object({
  user_answer: z.string(),
  master_answer: z.string(),
  question_type: questionTypeSchema,
})

export const lessonReviewFunnelStepSchema = z.object({
  questions: z.array(questionSchema),
  answers: z.record(z.string(), lessonReviewAnswerSchema),
})

export type QuestionFunnelStepContext = z.infer<typeof lessonReviewFunnelStepSchema>
export type QuestionFunnelStepKey = `REVIEW_${number}`
export type QuestionFunnelStepContextMap = Record<QuestionFunnelStepKey, QuestionFunnelStepContext>
